import { useContext, useEffect, useState } from "react";
import { IoCloseSharp, IoLanguage } from "react-icons/io5";
import { MdDashboard, MdRateReview } from "react-icons/md";
import { GiTripleCorn } from "react-icons/gi";
import { HiChevronDown } from "react-icons/hi";
import { SiFoursquarecityguide } from "react-icons/si";
import { FaBlogger, FaBus, FaInfoCircle } from "react-icons/fa";
import { BsGoogle } from "react-icons/bs";
import { AiOutlineLogout } from "react-icons/ai";
import { CgProfile } from "react-icons/cg";
import { Link } from "react-router-dom";
import { BiMenu } from "react-icons/bi";
import LangService from "../../services/LangService";
import { langsType } from "../../types/enums/API.types";
import LangContext from "../../context/LanguageContext";
const SideNav = (props: any) => {
  const [dropDwn, setDrpDown] = useState({
    isDropDown: false,
    dropDwnItem: "" as string | undefined,
  });
  const [mblNavActive, setmblNavActive] = useState(true); //TODO: mange state for responsive nav

  // const { data, errMsg, loading } = useFetch('lang/findAll')

  const handleLogout = () => {
    localStorage.removeItem("token");

    window.location.replace("http://localhost:3000/login");
  };

  const handleNavDropState = (menu: string) => {
    if (menu.length > 0 && dropDwn.dropDwnItem !== menu) {
      return menu;
    }
    if (menu.length > 0 && dropDwn.dropDwnItem === menu) {
      return " ";
    }
  };

  const [langApiData, setLangApiData] = useState<langsType[]>([]);
  const { lang, setLang } = useContext(LangContext);
  const langService = LangService;
  const fetchLanguages = async () => {
    try {
      const res = await langService.getAllLanguages();
      setLangApiData(res.data.languages);
      setLang(res.data.languages[0]);
    } catch (error) {
      console.log(error);
    }
  };

  const changeLang = (lang_id: string) => {
    const index = langApiData.findIndex((item) => item.id === lang_id);
    setLang(langApiData[index]);
  };
  useEffect(() => {
    fetchLanguages();
  }, []);

  return (
    <div className="grid md:grid-cols-12 lg:grid-cols-11 xl:grid-cols-10 md:gap-4 relative">
      {/* mobile nav */}
      <div className="md:hidden bg-primary-base py-4 text-white">
        <div className="container mx-auto px-4 flex items-center justify-between">
          <h2 className="font-bold text-xl">Ultimate Trekking</h2>
          <BiMenu
            className="text-xl"
            onClick={() => setmblNavActive(!mblNavActive)}
          />
        </div>
      </div>
      {/* desktop nav  */}
      <aside
        className={`md:col-span-4 lg:col-span-3 xl:col-span-2 h-screen transition-all duration-300 sticky top-0 ${
          !mblNavActive &&
          "h-0 overflow-hidden transition-all -top-[10%] duration-300"
        }`}
        aria-label="Sidebar"
      >
        <div className="h-screen overflow-y-auto py-4 px-3 bg-gray-50 rounded dark:bg-gray-800 dark:text-white flex flex-col justify-between">
          <div className="my-4">
            <span className="self-center text-xl font-semibold whitespace-nowrap dark:text-white">
              Ultimate-Trekking
            </span>

            {/* <h2>MENU</h2> */}

            <Link to="/">
              <div className="sidenav">
                <MdDashboard />
                <p>Dashboard</p>
              </div>
            </Link>

            <Link to="/languages">
              <div className="sidenav">
                <IoLanguage />
                <p>Language</p>
              </div>
            </Link>

            <div>
              <div
                className="flex items-center justify-between pr-2 transition  hover:bg-gray-200 dark:hover:bg-gray-700  dark:text-white rounded-md cursor-pointer p-3 my-2"
                onClick={() =>
                  setDrpDown({
                    isDropDown: true,
                    dropDwnItem: handleNavDropState("packages"),
                  })
                }
              >
                <div className="flex items-center space-x-2">
                  <GiTripleCorn />
                  <p>Packages</p>
                </div>
                <div>
                  <HiChevronDown
                    className={`transition-all duration-300 ${
                      dropDwn.isDropDown &&
                      dropDwn.dropDwnItem === "packages" &&
                      "h-0 overflow-hidden transform rotate-90 transition-all duration-300"
                    }`}
                  />
                  <IoCloseSharp
                    className={`transform rotate-90 transition-all duration-300 h-0 overflow-hidden ${
                      dropDwn.isDropDown &&
                      dropDwn.dropDwnItem === "packages" &&
                      "h-auto transition-all duration-300"
                    }`}
                  />
                </div>
              </div>
              <div
                className={` ${
                  dropDwn.isDropDown && dropDwn.dropDwnItem === "packages"
                    ? "bg-gray-200 dark:bg-gray-600 p-4  h-auto transition-all duration-300 top-0"
                    : "px-4 h-0 overflow-hidden transition-all duration-300 -top-24"
                }`}
              >
                <Link to="/package-categories">
                  <div className="space-y-2 py-1 cursor-pointer hover:text-primary-base">
                    Package Category
                  </div>
                </Link>
                <hr className="my-2 border-gray-400" />
                <Link to="/packages">
                  <div className="space-y-2 py-1 cursor-pointer hover:text-primary-base">
                    Add Packages
                  </div>
                </Link>
                <hr className="my-2 border-gray-400" />
                {/* <Link to="/add_pkg_amenities">
                  <div className="space-y-2 py-1 cursor-pointer hover:text-primary-base">
                    Add Package Amenities
                  </div>
                </Link> */}
                <hr className="my-2 border-gray-400" />
              </div>
            </div>
            {/* <Link to="/amenities">
              <div className="sidenav">
                <FaBus />
                <p>Amenities</p>
              </div>
            </Link> */}
            <Link to="/travel-guide">
              <div className="sidenav">
                <SiFoursquarecityguide />
                <p>Travel Guide</p>
              </div>
            </Link>

            <div>
              <div
                className="flex items-center justify-between pr-2 transition  hover:bg-gray-200 dark:hover:bg-gray-700 rounded-md cursor-pointer p-3 my-2"
                onClick={() =>
                  setDrpDown({
                    isDropDown: true,
                    dropDwnItem: handleNavDropState("blog"),
                  })
                }
              >
                <div className="flex items-center space-x-2">
                  <FaBlogger />
                  <p>Blog</p>
                </div>
                <div>
                  <HiChevronDown
                    className={`transition-all duration-300 ${
                      dropDwn.isDropDown &&
                      dropDwn.dropDwnItem === "blog" &&
                      "h-0 overflow-hidden transform rotate-90 transition-all duration-300"
                    }`}
                  />
                  <IoCloseSharp
                    className={`transform rotate-90 transition-all duration-300 h-0 overflow-hidden ${
                      dropDwn.isDropDown &&
                      dropDwn.dropDwnItem === "blog" &&
                      "h-auto transition-all duration-300"
                    }`}
                  />
                </div>
              </div>
              <div
                className={` ${
                  dropDwn.isDropDown && dropDwn.dropDwnItem === "blog"
                    ? "bg-gray-200 dark:bg-gray-600 p-4  h-auto transition-all duration-300 top-0"
                    : "px-4 h-0 overflow-hidden transition-all duration-300 -top-24"
                }`}
              >
                <Link to="/blog-category">
                  <div className="space-y-2 py-1 cursor-pointer hover:text-primary-base">
                    Blog Category
                  </div>
                </Link>
                <hr className="my-2 border-gray-400" />
                <Link to="/">
                  <div className="space-y-2 py-1 cursor-pointer hover:text-primary-base">
                    Add Blog
                  </div>
                </Link>
              </div>
            </div>

            <div>
              <div
                className="flex items-center justify-between pr-2 transition  hover:bg-gray-200  dark:hover:bg-gray-700 rounded-md cursor-pointer p-3 my-2"
                onClick={() =>
                  setDrpDown({
                    isDropDown: true,
                    dropDwnItem: handleNavDropState("review"),
                  })
                }
              >
                <div className="flex items-center space-x-2">
                  <MdRateReview />
                  <p>Review</p>
                </div>
                <div>
                  <HiChevronDown
                    className={`transition-all duration-300 ${
                      dropDwn.isDropDown &&
                      dropDwn.dropDwnItem === "review" &&
                      "h-0 overflow-hidden transform rotate-90 transition-all duration-300"
                    }`}
                  />
                  <IoCloseSharp
                    className={`transform rotate-90 transition-all duration-300 h-0 overflow-hidden ${
                      dropDwn.isDropDown &&
                      dropDwn.dropDwnItem === "review" &&
                      "h-auto transition-all duration-300"
                    }`}
                  />
                </div>
              </div>
              <div
                className={` ${
                  dropDwn.isDropDown && dropDwn.dropDwnItem === "review"
                    ? "bg-gray-200 dark:bg-gray-600 p-4  h-auto transition-all duration-300 top-0"
                    : "px-4 h-0 overflow-hidden transition-all duration-300 -top-24"
                }`}
              >
                {/* <Link to="/" > */}
                <div className="space-y-2 py-1 hover:text-gray-800 cursor-not-allowed">
                  Review Categoires
                </div>
                {/* </Link> */}
                <hr className="my-2 border-gray-400" />
                <Link to="/review">
                  <div className="space-y-2 py-1 cursor-pointer hover:text-primary-base">
                    Add Review
                  </div>
                </Link>
              </div>
            </div>

            <Link to="/booking">
              <div className="sidenav">
                <FaInfoCircle />
                <p>Booking</p>
              </div>
            </Link>

            <Link to="/meta-tags">
              <div className="sidenav">
                <BsGoogle />
                <p>Meta Tags</p>
              </div>
            </Link>

            <Link to="/">
              <div className="sidenav">
                <CgProfile />
                <p>Profile</p>
              </div>
            </Link>

            <div className="sidenav" onClick={() => handleLogout()}>
              <AiOutlineLogout />
              <p>Log out</p>
            </div>
          </div>

          {/* bottom part  */}
          <div className="flex  flex-col-reverse gap-3">
            <div className="">
              Active :{" "}
              <span className="font-bold text-primary-base">{lang}</span>
            </div>
            <select
              name=""
              id=""
              className="p-2 shadow bg-gray-100 dark:bg-gray-700"
              onChange={(e) => {
                if (e.target.value !== "") changeLang(e.target.value);
              }}
            >
              <option value="">--change language--</option>
              {langApiData.map((item, i) => (
                <option value={item.id}>{item.lang}</option>
              ))}
            </select>
          </div>
        </div>
      </aside>
      <div className="md:col-span-8 lg:col-span-8 xl:col-span-8">
        <div className="container mx-auto px-4 lg:px-8">{props.children}</div>
      </div>
    </div>
  );
};

export default SideNav;
